import styled from 'styled-components'

import { Body01, BodyBold01 } from '~/components/common/typography'

export const Option = styled(Body01)`
  display: block;
  margin-bottom: 4px;
`

export const Question = styled(BodyBold01)`
  display: block;
  margin-bottom: 8px;
`

export const Creator = styled(Body01)`
  display: block;
  color: ${props => props.theme._neo.textColor02};
  margin-bottom: 16px;
`

export const NoBulletUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`
